import gsap from 'gsap';

export default function(){
	const blocks         = document.querySelectorAll('[data-block]');
	const customSections = document.querySelectorAll('[data-custom-section]');
	const allSections = Array.from(blocks).concat(Array.from(customSections));

	if ( allSections.length === 0 ) return;

	// Create array of block data (only include blocks with titles)
	const blockData = Array.from(allSections).map(block => ({
		id: block.id,
		title: block.dataset.blockTitle,
	})).filter(item => item.title);

	const skipLinksBlock = document.querySelector('.block--floating-skip-links');
	const skipLinksContainer = document.querySelector('.block--floating-skip-links > div nav');
	const skipLinksList = document.querySelector('.block--floating-skip-links > div nav ul');
	const svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" fill="none"><circle cx="13.5" cy="13.5" r="12.9" stroke="#fff" stroke-width="1.2"/><path fill="#fff" d="M13.089 19.734a.7.7 0 0 0 .99 0l4.455-4.455a.7.7 0 0 0-.99-.99l-3.96 3.96-3.96-3.96a.7.7 0 0 0-.99.99l4.455 4.455Zm-.205-11.809V19.24h1.4V7.925h-1.4Z"/></svg>`;
	const plusIcon = document.querySelector('.block--floating-skip-links > div .icon:first-child');
	const minusIcon = document.querySelector('.block--floating-skip-links > div .icon:last-child');

	if (  skipLinksContainer === null ) return;
	if (  blockData.length === 0 ) {
		skipLinksContainer.parentNode.classList.add('hidden'); // NO links, hide the block
		return;
	}

	gsap.set( skipLinksContainer, { autoAlpha: 0, height: 0 } );

	// Create the navigation list
	blockData.forEach(block => {
		const li = document.createElement('li')
		const link = document.createElement('a')
		link.classList.add('group')
		
		link.href = `#${block.id}`;
		link.setAttribute('data-scroll', 'scroll-to');
		
		// Create wrapper for text and icon
		link.innerHTML = `
			<span class="flex items-center gap-x-8 *:pointer-events-none">
				<span class="icon group-hover:[&_svg_circle]:fill-white group-hover:[&_svg_path]:fill-deep-blue">${svgIcon}</span>
				<span>${block.title}</span>
			</span>
		`;
		
		li.appendChild(link);
		skipLinksList.appendChild(li);
	});


	// Click event to toggle the skip links
	skipLinksBlock.addEventListener('click', function() {
		const target = skipLinksBlock.querySelector(':scope > div')
		target.classList.toggle('open');
		

		if ( target.classList.contains('open') ) {
			gsap.to(  plusIcon, { autoAlpha: 0, duration: 0.5 });
			gsap.to( minusIcon, { autoAlpha: 1, duration: 0.5 });
			gsap.to( skipLinksContainer, { autoAlpha: 1, height: 'auto', duration: 0.5 });
			setTimeout(() => {
				skipLinksContainer.style.overflowY = 'auto';
			}, 600);
		} else {
			gsap.to(  plusIcon, { autoAlpha: 1, duration: 0.5 });
			gsap.to( minusIcon, { autoAlpha: 0, duration: 0.5 });
			gsap.to( skipLinksContainer, { autoAlpha: 0, height: 0, duration: 0.5 });
			skipLinksContainer.style.overflowY = 'hidden';
		}
	});



	// Loading animation
	gsap.set( skipLinksBlock, { autoAlpha: 0 } );
	if ( window.innerWidth < 768 ) {
		window.addEventListener('scroll', () => {
			if ( window.scrollY > 400 ) {
				gsap.to( skipLinksBlock, { autoAlpha: 1, duration: 0.3 });
			}
		});
	} else {
		gsap.to( skipLinksBlock, { autoAlpha: 1, duration: 0.3 });
	}

}
